import actions from './actions'

export default function TechniciansReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_TECHNICIAN:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_TECHNICIAN:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_TECHNICIAN:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_TECHNICIAN:
      return {
        ...state,
        editing: { technicianID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_TECHNICIAN_RECIEVED ||
      actions.UPDATE_TECHNICIAN_RECIEVED ||
      actions.DELETE_TECHNICIAN_RECIEVED:
      return {
        ...state,
        editing: { technicianID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
